<template>
  <footer
    class="w-full px-4 md:px-8 py-6 bg-gray-100 text-gray-700 mt-auto min-h-[72px]"
  >
    <div
      class="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4"
    >
      <div class="text-base font-semibold">mulberry’ss</div>
      <div
        class="flex flex-col md:flex-row items-center gap-2 md:gap-6 text-xs md:text-sm text-gray-500"
      >
        <span>© {{ new Date().getFullYear() }} mulberry’ss</span>
        <span class="hidden md:inline">|</span>
        <span>Всі права захищені</span>
        <span class="hidden md:inline">|</span>
        <NuxtLink to="/privacy" class="hover:underline"
          >Політика конфіденційності</NuxtLink
        >
        <NuxtLink to="/contacts" class="hover:underline">Контакти</NuxtLink>
      </div>
    </div>
  </footer>
</template>
